import { render, staticRenderFns } from "./qrLink.vue?vue&type=template&id=3bbdb243&scoped=true"
import script from "./qrLink.vue?vue&type=script&lang=js"
export * from "./qrLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbdb243",
  null
  
)

export default component.exports